// Generated by purs version 0.15.15
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_AdminUserRole from "../Ouroboros.Models.Brands.AdminUserRole/index.js";
import * as Ouroboros_Models_Brands_AdminUserStatus from "../Ouroboros.Models.Brands.AdminUserStatus/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_InviteRejectionReason from "../Ouroboros.Models.Brands.InviteRejectionReason/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_SeatCount from "../Ouroboros.Models.Brands.SeatCount/index.js";
import * as Ouroboros_Models_Brands_UUID from "../Ouroboros.Models.Brands.UUID/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readFieldsCons = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(Ouroboros_Models_Brands_Email.readEmail);
var readMaybe = /* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp);
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var decodeInviteResult = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "accepted";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(Ouroboros_Models_Brands_Email.readEmail))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "rejected";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "reason";
    }
})(Ouroboros_Models_Brands_InviteRejectionReason.readInviteRejectionReason)(Simple_JSON.readFieldsNil)()())()())))(Simple_JSON.readFieldsNil)()())()()));
var decodeAdminUserListResponse = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "items";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "activatedAt";
    }
})(readMaybe)(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Ouroboros_Models_Brands_UUID.readUUID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "invitedAt";
    }
})(readMaybe)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "role";
    }
})(Ouroboros_Models_Brands_AdminUserRole.readAdminUserRole)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_AdminUserStatus.readAdminUserStatus)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "suspendedAt";
    }
})(readMaybe)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "seatLimit";
    }
})(Ouroboros_Models_Brands_SeatCount.readSeatCount)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "seatsUsed";
    }
})(Ouroboros_Models_Brands_SeatCount.readSeatCount)(Simple_JSON.readFieldsNil)()())()())()()));
export {
    decodeAdminUserListResponse,
    decodeInviteResult
};
//# sourceMappingURL=index.js.map
